"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _2 = require("../");

var _functions = require("../../resources/functions/");

var _color = _interopRequireDefault(require("color"));

var _lodash = _interopRequireDefault(require("lodash"));

var _moment = _interopRequireDefault(require("moment"));

require("./AnalyticsReportRegVsPub.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class AnalyticsReportRegVsPub extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      style: {},
      colors: ["white", "rgba(255,255,255,0.25)"],
      data: undefined,
      chartData: [{
        "id": "dm:published",
        "label": "Publisert",
        "value": 0
      }, {
        "id": "dm:unpublished",
        "label": "Ikke publisert",
        "value": 1
      }],
      loading: true
    });

    _defineProperty(this, "componentDidUpdate", (prevProps, prevState) => {
      if (prevProps.report !== this.props.report) {
        this.getReport();
      }

      if (prevProps.theme !== this.props.theme || prevProps.backgroundColor !== this.props.backgroundColor) {
        this.getColors();
      }

      if (prevState.data !== this.state.data) {
        this.getChartData();
        this.getListData();
      }
    });

    _defineProperty(this, "getColors", () => {
      let _this$props = this.props,
          backgroundColor = _this$props.backgroundColor,
          theme = _this$props.theme;
      backgroundColor = (0, _color.default)(backgroundColor);
      let color;

      if (theme) {
        backgroundColor = "white";
        color = theme && theme.primaryColor || "black";
      } else if (backgroundColor.isDark()) {
        color = "white";
      } else {
        color = "black";
      }

      const style = {
        backgroundColor: backgroundColor,
        color: color
      }; // colors

      let colors = [];

      if (color === "white") {
        colors = ["white", "rgba(255,255,255,.25)"];
      } else {
        colors = [color, "rgba(0,0,0,.125)"];
      }

      this.setState({
        style: style,
        colors: colors
      });
    });

    _defineProperty(this, "getReport", () => {
      let report = this.props.report; // set state

      this.setState({
        loading: true
      });

      if (!report) {
        return false;
      } // load data


      const data = (0, _functions.getGaDataByMetrics)(report);

      if (!data) {
        return false;
      }

      this.setState({
        loading: false,
        data: data
      });
    });

    _defineProperty(this, "getChartData", () => {
      const _this$state = this.state,
            data = _this$state.data,
            colors = _this$state.colors;

      if (!data) {
        return false;
      }

      const total = data["primus:total"] && data["primus:total"].total || 0;
      const published = data["dm:published"] && data["dm:published"].total || 0;
      const unpublished = data["dm:unpublished"] && data["dm:unpublished"].total || 0;
      const chartData = [{
        "id": "dm:published",
        "label": "Publisert",
        "value": published
      }, {
        "id": "dm:unpublished",
        "label": "Ikke publisert",
        "value": unpublished
      }];
      this.setState({
        summary: {
          total: total,
          published: published,
          unpublished: unpublished
        },
        chartData: chartData
      });
    });

    _defineProperty(this, "getListData", () => {
      const data = this.state.data;

      if (!data) {
        return false;
      }

      const total = data["primus:total"] && data["primus:total"].data || [];
      const published = data["dm:published"] && data["dm:published"].data || [];
      const unpublished = data["dm:unpublished"] && data["dm:unpublished"].data || [];
      let listData = [];
      total.map((row, index) => {
        const data = row.data,
              total = row.total;
        const label = data[0]["ga:objectType"];
        const listItem = {
          "label": label,
          "total": total,
          "published": published[index].total,
          "unpublished": unpublished[index].total
        };

        if (total) {
          listData.push(listItem);
        }
      });
      this.setState({
        listData: listData
      });
    });

    _defineProperty(this, "renderTooltip", props => {
      const data = props.data;
      return _react.default.createElement(_2.ChartTooltip, null, _react.default.createElement("h2", {
        className: "admin-tooltip__title"
      }, "Publisert vs. registrert"), _react.default.createElement("ul", null, _react.default.createElement("li", null, _react.default.createElement("div", {
        className: "admin-tooltip__chip",
        style: {
          backgroundColor: "white"
        }
      }), _react.default.createElement("b", {
        className: "admin-tooltip__value"
      }, "Publisert"), _react.default.createElement("i", {
        className: "admin-tooltip__value"
      }, _react.default.createElement(_2.FormatMetric, {
        type: "INTEGER",
        value: 1000
      }))), _react.default.createElement("li", null, _react.default.createElement("div", {
        className: "admin-tooltip__chip",
        style: {
          backgroundColor: "rgba(255,255,255,0.25"
        }
      }), _react.default.createElement("b", {
        className: "admin-tooltip__value"
      }, "Registert"), _react.default.createElement("i", {
        className: "admin-tooltip__value"
      }, _react.default.createElement(_2.FormatMetric, {
        type: "INTEGER",
        value: 50
      })))));
    });

    _defineProperty(this, "renderChart", () => {
      const chartTitle = this.props.chartTitle;
      const _this$state2 = this.state,
            chartData = _this$state2.chartData,
            colors = _this$state2.colors;
      return _react.default.createElement(_2.Chart, {
        type: "pie",
        data: chartData,
        colors: colors,
        enableSlicesLabels: false
      });
    });

    _defineProperty(this, "renderListItem", (item, index) => {
      const label = item.label,
            total = item.total,
            unpublished = item.unpublished,
            published = item.published;
      const value = published;
      const percentage = published / total * 100;
      const style = this.state.style;
      const pctStyle = {
        backgroundColor: style && style.color || "black",
        width: percentage + "%"
      };
      return _react.default.createElement("li", {
        className: "list-item",
        key: index
      }, _react.default.createElement("b", {
        className: "list-item__label"
      }, item['label']), _react.default.createElement("i", {
        className: "sparkline"
      }, _react.default.createElement("i", {
        className: "sparkline__bar",
        style: pctStyle
      })), _react.default.createElement("b", {
        className: "list-item__value"
      }, _react.default.createElement(_2.FormatMetric, {
        type: "PERCENT",
        value: percentage,
        decimals: "1"
      })));
    });

    _defineProperty(this, "renderDetails", () => {
      const listTitle = this.props.listTitle;
      const listData = this.state.listData;

      if (!listData) {
        return false;
      }

      return _react.default.createElement("section", {
        className: "details"
      }, _react.default.createElement("ul", {
        className: "list"
      }, listData.map(this.renderListItem)));
    });

    _defineProperty(this, "renderLegend", () => {
      const _this$state3 = this.state,
            summary = _this$state3.summary,
            colors = _this$state3.colors;

      if (!summary) {
        return false;
      }

      const total = summary.total,
            published = summary.published,
            unpublished = summary.unpublished;
      return _react.default.createElement("section", {
        className: "admin-legend"
      }, _react.default.createElement("ul", null, _react.default.createElement("li", null, _react.default.createElement("div", {
        className: "admin-legend__chip",
        style: {
          backgroundColor: colors[1]
        }
      }), _react.default.createElement("b", {
        className: "admin-legend__label"
      }, "Primus"), _react.default.createElement("i", {
        className: "admin-legend__value"
      }, _react.default.createElement(_2.FormatMetric, {
        type: "INTEGER",
        value: total
      }))), _react.default.createElement("li", null, _react.default.createElement("div", {
        className: "admin-legend__chip",
        style: {
          backgroundColor: colors[0]
        }
      }), _react.default.createElement("b", {
        className: "admin-legend__label"
      }, "DigitaltMuseum"), _react.default.createElement("i", {
        className: "admin-legend__value"
      }, _react.default.createElement(_2.FormatMetric, {
        type: "INTEGER",
        value: published
      })))));
    });

    _defineProperty(this, "renderSummary", () => {
      const _this$props2 = this.props,
            title = _this$props2.title,
            loadingTitle = _this$props2.loadingTitle;
      const _this$state4 = this.state,
            summary = _this$state4.summary,
            colors = _this$state4.colors,
            style = _this$state4.style;
      const loading = this.state.loading || this.props.loading;

      if (loading || !summary) {
        return _react.default.createElement("section", {
          className: "summary"
        }, _react.default.createElement("h1", {
          className: "summary__title"
        }, loadingTitle), _react.default.createElement(_2.WidgetSpinner, {
          style: style
        }));
      }

      const total = summary.total,
            published = summary.published,
            unpublished = summary.unpublished;
      const percentage = published / total * 100;
      return _react.default.createElement("section", {
        className: "summary"
      }, _react.default.createElement("h1", {
        className: "summary__title"
      }, title), _react.default.createElement("h2", {
        className: "summary__value"
      }, _react.default.createElement(_2.FormatMetric, {
        type: "PERCENT",
        value: percentage,
        decimals: "0"
      })));
    });
  }

  componentDidMount() {
    this.getReport();
    this.getColors();
  }

  render() {
    const style = this.state.style;
    return _react.default.createElement(_2.Widget, _extends({}, this.props, {
      style: style
    }), _react.default.createElement(_2.WidgetHeader, null, this.renderSummary(), this.renderChart(), this.renderLegend()), _react.default.createElement(_2.WidgetFooter, null, this.renderDetails()));
  }

}

_defineProperty(AnalyticsReportRegVsPub, "defaultProps", {
  backgroundColor: "white",
  widgetType: "analytics-reg-vs-pub",
  widgetSize: "1:1",
  loadingTitle: "Primus vs. DigitaltMuseum",
  title: "Primus vs. DigitaltMuseum",
  listTitle: "Object types"
});

AnalyticsReportRegVsPub.propTypes = process.env.NODE_ENV !== "production" ? {
  title: _propTypes.default.string,
  listTitle: _propTypes.default.string,
  loadingTitle: _propTypes.default.string
} : {};
var _default = AnalyticsReportRegVsPub;
exports.default = _default;
module.exports = exports.default;